import type { Route } from "./+types/courses";
import Page from "../pages/Courses";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
import { liveOffers } from "../lib/offers";
export async function loader() {
  const [items, offers] = await Promise.all([legacy.courses(), liveOffers()]);
  return { items, maven: offers.all };
}
export const meta = () => pageMeta({ title: "Courses: live cohorts on Maven and self-paced | Gazar", description: "Live cohorts and free live sessions on Maven, plus self-paced, buy-once courses on system design, clean code and interview prep.", path: "/courses", image: OG_IMAGE.courses });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} maven={loaderData.maven} />; }
